import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(3),
  },
  headerTitleText: {
    fontSize: 'clamp(12px, 1.3021vw, 27px)',
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: 'Montserrat',
  },
  dashboardSectionRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  tabs: {
    width: '100%',
    '& .MuiTabs-flexContainer': {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    '& .MuiTab-root:first-of-type': {
      marginRight: theme.spacing(1),
    },
  },
  tab: {
    width: 'clamp(120px, 15.63vw, 320px)',
    height: 'clamp(24px, 3.13vw, 64px)',
    borderRadius: '5px 5px 0 0',
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 'clamp(8px, 0.833334vw, 17px)',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 0,
    padding: theme.spacing(1, 2),
    backgroundColor: '#E2E2E2',
    color: theme.palette.primary.gray,
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.white,
    },
    [theme.breakpoints.down('md')]: {
      width: 'clamp(150px, 16.67vw, 360px)',
      height: 'clamp(24px, 3.13vw, 64px)',
      padding: '17px 9px',
      borderRadius: '5px 5px 0 0',
    },
  },
  tabIndicator: {
    display: 'none',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '2px solid #E2E2E2',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'start',
      gap: theme.spacing(1),
    },
  },
  headerTitle: {
    display: 'flex',
    color: theme.palette.background.main,
    alignItems: 'center',
    gap: '8px',
    '& .MuiSvgIcon-root': {
      fontSize: 'clamp(20px, 2.6042vw, 40px)',
    },
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      fontSize: 'clamp(10px, 0.83vw, 18px)',
      color: theme.palette.primary.gray,
      marginLeft: theme.spacing(1),
    },
  },
  totalCard: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 16,
  },
  totalLabel: {
    letterSpacing: 0.5,
    color: theme.palette.primary.skyBlue,
    fontSize: 'clamp(10px, 1.3021vw, 27px)',
    fontWeight: 700,
  },
  totalAmount: {
    fontSize: 'clamp(28px, 3.65vw, 75px)',
    fontWeight: 700,
    color: theme.palette.primary.gray,
  },
  percentage: {
    display: 'flex',
    marginLeft: theme.spacing(1),
    fontSize: 'clamp(10px, 1.3021vw, 27px)',
    fontWeight: 700,
    alignItems: 'center',
    '& svg': {
      marginRight: theme.spacing(0.5),
    },
    '& .MuiSvgIcon-root': {
      fontSize: 'clamp(10px, 1.3021vw, 27px)',
    },
  },
  positive: {
    color: theme.palette.success.main,
    '& svg': {
      color: theme.palette.success.main,
    },
  },
  negative: {
    color: theme.palette.error.main,
    '& svg': {
      color: theme.palette.error.main,
    },
  },
  totalDescription: {
    fontSize: 'clamp(8px, 1.0417vw, 21px)',
    fontWeight: 400,
    color: theme.palette.primary.gray,
  },
  summaryCard: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 10,
    padding: 'clamp(8px, 1.04vw, 21px)',
    boxShadow: '0px 0px 4px 0px #00000040',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  cardAmount: {
    fontWeight: 700,
    color: theme.palette.primary.gray,
    fontSize: 'clamp(12px, 1.3021vw, 27px)',
  },
  cardItemsContainer: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      display: 'row',
    },
  },
  cardItemIcon: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    marginRight: theme.spacing(1),
  },
  cardItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
    color: theme.palette.primary.gray,
    fontSize: 'clamp(11px, 0.833334vw, 17px)',
    '& span': {
      fontWeight: 700,
      justifySelf: 'flex-end',
    },
  },
  cardItemName: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      color: theme.palette.primary.gray,
      marginRight: theme.spacing(1),
      fontWeight: 400,
    },
  },
  detail: {
    color: theme.palette.primary.gray,
    fontSize: 'clamp(12px, 1vw, 21px)',
    fontWeight: 400,
    lineHeight: 1.2,
    marginTop: theme.spacing(1),
  },
  chartCard: {
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    borderRadius: 10,
    padding: theme.spacing(3),
    boxShadow: '0px 0px 4px 0px #00000040',
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  chartHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  chartPlaceholder: {
    height: 260,
    borderRadius: 12,
    background: 'linear-gradient(180deg, rgba(0,123,255,0.08) 0%, rgba(0,123,255,0.02) 100%)',
    border: '1px dashed rgba(0, 0, 0, 0.08)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mainCardsRow: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },
  summaryCardsRow: {
    display: 'flex',
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  chartsRow: {
    display: 'flex',
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  cardContent: {
    flex: 1,
  },
  valueRow: {
    display: 'flex',
    alignItems: 'baseline',
    marginTop: theme.spacing(1),
  },
  yearSelect: {
    alingSelf: 'start',
  },
  academicChartCard: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 10,
    padding: 'clamp(8px, 1.0417vw, 21px)',
    boxShadow: '0 2px 10px rgba(15, 35, 52, 0.06)',
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  percentageText: {
    fontSize: 'clamp(10px, 1.3021vw, 27px)',
    fontWeight: 700,
  },
}));

export default useStyles;
